<template>
  <div class="myaccount">
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <CommonHead></CommonHead>
    <div class="accountdetails">
      <sidebar></sidebar>
      <div class="orderspage invoicepage">
	  <h1 class="account-mobile">Invoices</h1>
        <b-card class="orderdetails" no-body>
          <b-tabs card>
            <b-tab title="Open Invoices" active>
              <div class="card-content">
                <p class="emptynote" v-if="openisempty == true">No Records Found.</p>
                <div class="boxgrid" v-for="(openinvoice,oik) in openinvoices" :key="oik">
                  <div class="orderamount">
                    <div class="boxorder">
                      <div class="samediv">
                        <span>Order #</span>
                        <p>{{openinvoice.salesid}}</p>
                      </div>
                      <div class="samediv">
                        <span>Invoice No.</span>
                        <p><a :href="openinvoice.invoicepdf" target="_blank">{{openinvoice.invoiceid}}</a></p>
                      </div>
                      <div class="samediv">
                        <span>Date</span>
                        <p>{{openinvoice.invdate}}</p>
                      </div>
                      <div class="samediv">
                        <span>Days Open</span>
                        <p>{{openinvoice.daysopen}}</p>
                      </div>
                    </div>
                    <div class="boxamount">
                      <div class="samediv">
                        <p>${{openinvoice.amount}}</p>
                        <span>Amount</span>
                      </div>
                      <div class="samediv">
                        <p>${{openinvoice.balance}}</p>
                        <span>Balance</span>
                      </div>
                    </div>
                  </div>
                </div>
                <p class="invoicenote">To pay invoices, please remit to:</p>
                <p class="invoicenote">&nbsp;</p>
                <p class="invoicenote">RM COCO Décor Ltd.<br>
                1389 Southern Expressway<br>
                P.O. Box 1270<br>
                Cape Girardeau, MO 63702-1270</p>
                <p class="invoicenote">&nbsp;</p>
                <p class="invoicenote">For questions regarding your account, please contact Accounts Relations at 1.800.325.8025 or email <a href="mailto:accountrelations@rmcoco.com">accountrelations@rmcoco.com</a>.</p>
              </div>
            </b-tab>
            <b-tab title="Paid Invoices">
              <div class="card-content">
                <div class="pickerarea">
                  <date-picker v-model="time1" valueType="format" @change="pickchange" placeholder="From Date"></date-picker>
                </div>
                <p class="emptynote" v-if="paidisempty == true">No Records Found.</p>
                <div class="boxgrid" v-for="(closeinvoice,cik) in closeinvoices" :key="cik">
                  <div class="orderamount">
                    <div class="boxorder">
                      <div class="samediv">
                        <span>Order #</span>
                        <p>{{closeinvoice.salesid}}</p>
                      </div>
                      <div class="samediv">
                        <span>Invoice No.</span>
                        <p><a :href="closeinvoice.invoicepdf" target="_blank">{{closeinvoice.invoiceid}}</a></p>
                      </div>
                      <div class="samediv">
                        <span>Closed Date</span>
                        <p>{{closeinvoice.closeddate}}</p>
                      </div>
                    </div>
                    <div class="boxamount">
                      <div class="samediv">
                        <p>${{closeinvoice.amount}}</p>
                        <span>Amount</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </b-card>
      </div>
    </div>
    <CommonFoot></CommonFoot>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Sidebar from "@/components/Sidebar";
import CommonHead from "@/components/CommonHead";
import CommonFoot from "@/components/CommonFoot";
import ResourceMixin from "../../mixins/resources";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css'

export default {
  components: {
    Sidebar,
    CommonHead,
    CommonFoot,
    DatePicker,
    Loading
  },
  mixins: [ResourceMixin],
  mounted() {
      this.isLoading = true;
      this.$store.dispatch("loadOpenInvoices").then(openinvoices => {
          this.openinvoices = openinvoices.data;
          if(this.openinvoices.length < 1){
            this.openisempty = true;
          }else{
            this.openisempty = false;
          }
      });
      this.$store.dispatch("loadCloseInvoices",{seldate:""}).then(closeinvoices => {
          this.closeinvoices = closeinvoices.data;
          if(this.closeinvoices.length < 1){
            this.paidisempty = true;
          }else{
            this.paidisempty = false;
          }
      });
      this.isLoading = false;
	 
  },
  computed: {
       ...mapGetters(["user"])
  },
  data() {
    return {
      openinvoices:[],
      closeinvoices:[],
      paidisempty:false,
      openisempty:false,
      isLoading: false,
      time1: null,
	    getpdf:'',
      breadcrumb: [
        {
          text: "My Account",
          active: true
        }
      ]
    };
  },
  methods:{
    GetPDF(invoiceid){
      this.$store.dispatch("loadPDFInvoice",{invoiceid:invoiceid,customer_id:this.user.accountnumber}).then(response => {
            
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'invoice.pdf');
        document.body.appendChild(link);
        link.click();
      });
    },
    pickchange(){
        let seldate = this.time1;
        this.isLoading = true;
        this.$store.dispatch("loadCloseInvoices",{seldate:seldate}).then(closeinvoices => {
            this.closeinvoices = closeinvoices.data;
            if(this.closeinvoices.length < 1){
                this.paidisempty = true;
            }else{
                this.paidisempty = false;
            }
        }).finally(() => {
            this.isLoading = false;
        });
    }
  }
};
</script>
<style>
.accountdetails .orderspage .orderdetails {
  width: 100%;
  border-radius: 0;
  border: none;
  max-width: 1110px;
  padding-right: 40px;
  box-sizing: border-box;
}

.accountdetails .orderspage .orderdetails .card-header {
  padding: 0;
  border-radius: 0;
  border: none;
  background-color: transparent;
  padding-bottom: 20px;
  border-bottom: 1px solid #d2d2d2;
}

.accountdetails .orderspage .orderdetails .card-header .card-header-tabs {
  margin: 0;
  border: 0;
  display: flex;
  justify-content: space-between;
}

.accountdetails .orderspage .orderdetails .card-header .nav-tabs .nav-item {
  margin: 0;
  border: 0;
  padding: 0;
}

.accountdetails .orderspage .orderdetails .card-header .nav-tabs .nav-link.active,
.accountdetails .orderspage .orderdetails .card-header .nav-tabs .nav-item.show .nav-link,
.accountdetails .orderspage .orderdetails .card-header .nav-tabs .nav-link {
  background: transparent;
  padding: 1rem 3rem;
  margin: 0;
  border: 0;
}

.accountdetails .orderspage .orderdetails .card-header .nav-tabs .nav-link.active {
  padding: 1rem 3rem;
  background: #d2d2d2;
}

.accountdetails .orderspage .orderdetails .card-header .nav-tabs .nav-link:hover {
  background: #d2d2d2;
}

.accountdetails .orderspage .orderdetails .card-header .nav-tabs .nav-link {
  color: #303030;
  font-size: 16px;
  font-weight: 500;
}

.accountdetails .orderspage .orderdetails .card-header .nav-tabs .nav-link:hover {
  text-decoration: none;
}

.accountdetails .orderspage .orderdetails .tab-content .card-body {
  padding: 30px 0 0 0;
}

.accountdetails .orderspage .orderdetails .tab-content .card-body .card-content {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 90px;
}

.accountdetails .orderspage .orderdetails .tab-content .card-body .card-content .boxgrid {
  width: 47.6%;
  padding: 15px 25px;
}

.accountdetails .orderspage .orderdetails .tab-content .card-body .card-content .boxgrid .samediv {
  width: auto;
  margin-right: 10px;
}

.accountdetails .orderspage .orderdetails .tab-content .card-body .card-content .boxgrid .samediv:nth-child(3) {
  width: 100%;
}

.accountdetails .orderspage .orderdetails .tab-content .card-body .card-content .boxgrid:nth-child(2n + 2) {
  margin-right: 0;
}

.accountdetails .orderspage .orderdetails .card-body .prodimg {
  display: flex;
  justify-content: left;
  align-items: center;
  margin-top: 4px;
}

.accountdetails .orderspage .orderdetails .card-body .boxgrid .prodimg .imgview {
  max-width: 50px;
  width: 100%;
  border-radius: 3px;
  margin-right: 15px;
}

.accountdetails .orderspage .orderdetails .card-body .boxgrid .prodimg a {
  font-size: 12px;
  color: #303030;
  font-weight: 300;
  text-decoration: none;
}

.accountdetails .orderspage .orderdetails .card-body .boxgrid a.viewdetails {
  color: #303030;
  font-weight: 600;
  font-size: 14px;
  float: right;
  text-decoration: none;
}

.accountdetails .orderspage .orderdetails .card-body .boxgrid a.viewdetails:hover {
  text-shadow: 0px 0px 1px #303030;
}

.accountdetails .orderspage.invoicepage .orderdetails .card-header .card-header-tabs {
  justify-content: flex-start;
}

.accountdetails .orderspage.invoicepage .orderdetails .card-header .nav-tabs .nav-item {
  margin-right: 125px;
}

.accountdetails .orderspage.invoicepage .orderdetails .tab-content .card-body .card-content p.invoicenote {
  font-size: 14px;
  line-height: 24px;
  color: #303030;
  width: 100%;
  margin: 0;
  padding: 0;
  font-weight: normal;
}

.accountdetails .orderspage.invoicepage .orderdetails .tab-content .card-body .card-content .boxgrid .orderamount {
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
}

.accountdetails .orderspage.invoicepage .orderdetails .tab-content .card-body .card-content .boxgrid .samediv {
  width: 100%;
  margin: 0;
}

.accountdetails .orderspage.invoicepage .orderdetails .tab-content .card-body .card-content .boxgrid .samediv p {
  margin: 0;
}

.accountdetails .orderspage.invoicepage .orderdetails .tab-content .card-body .card-content .boxgrid .boxamount {
  width: 100%;
}

.accountdetails .orderspage.invoicepage .orderdetails .tab-content .card-body .card-content .boxgrid .boxamount span,
.accountdetails .orderspage.invoicepage .orderdetails .tab-content .card-body .card-content .boxgrid .boxamount p {
  font-weight: 500;
  font-size: 16px;
  color: #303030;
  float: right;
}

.pickerarea,
.emptynote {
  margin-bottom: 30px;
  width: 100%;
}

@media only screen and (max-width: 1680px) and (min-width: 1441px) {
  .accountdetails .inneraccount {
    margin-left: 26.3% !important;
  }
}

@media only screen and (max-width: 1440px) {
  .accountdetails .orderspage .orderdetails {
    max-width: 950px !important;
  }
  .accountdetails .orderspage .orderdetails .card-body .prodimg {
    width: 74%;
  }
}

@media only screen and (max-width: 1500px) and (min-width: 1420px) {
  .accountdetails .orderspage.invoicepage .orderdetails .tab-content .card-body .card-content .boxgrid .boxamount {
    width: 85%;
  }
}

@media only screen and (max-width: 1419px) {
  .accountdetails .orderspage.invoicepage .orderdetails .tab-content .card-body .card-content .boxgrid .boxamount {
    width: 100%;
    min-width: 160px;
  }
}

@media only screen and (max-width:1024px) and (min-width:768px) {
  .accountdetails .orderspage {
    margin-left: 260px !important;
    padding-left: 0;
  }
  .accountdetails .orderspage .orderdetails {
    max-width: 100% !important;
    padding: 0 20px;
  }
  .accountdetails .orderspage.invoicepage .orderdetails .card-header .nav-tabs .nav-item {
    margin-right: 0;
  }
  .accountdetails .orderspage .orderdetails .tab-content .card-body .card-content .boxgrid {
    width: 100%;
    padding: 15px 15px;
    max-width: 100%;
  }
  .accountdetails .orderspage .orderdetails .card-header .nav-tabs .nav-item {
    width: 100%;
  }
  .accountdetails .orderspage .orderdetails .card-header .nav-tabs .nav-link {
    font-size: 14px;
    padding: 1rem 2rem;
    background: #d2d2d2;
    margin-bottom: 20px;
    text-align: center;
  }
  .accountdetails .orderspage .orderdetails .card-header .card-header-tabs {
    justify-content: center;
  }
  .accountdetails .orderspage .orderdetails .card-header .nav-tabs .nav-link.active {
    padding: 1rem 2rem;
    margin-bottom: 20px;
    text-align: center;
    background: #303030;
    color: #fff;
  }
}

@media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 2) {
  .accountdetails .orderspage .orderdetails .card-header .card-header-tabs {
    -webkit-box-pack: space-between;
    justify-content: space-between;
  }
  .accountdetails .orderspage .orderdetails .card-header .nav-tabs .nav-item {
    width: auto;
  }
  .accountdetails .orderspage.invoicepage .orderdetails .card-header .nav-tabs .nav-item {
    margin-right: 30px;
  }
}

@media only screen and (max-width:767px) {
  .orderspage.invoicepage .card.orderdetails {
    margin-top: -180px;
  }
  .accountdetails .orderspage.invoicepage .orderdetails .card-header .card-header-tabs {
    justify-content: center;
  }
  .accountdetails .orderspage.invoicepage .orderdetails .card-header .nav-tabs .nav-item {
    margin-right: 0;
  }
}
</style>